import { useEffect, useState } from "react";

function ImagesInSQSItem() {
	const [progress, setProgress] = useState(0);

	useEffect(() => {
		const totalDurationMs = 6000;
		const intervalMs = 100;
		const increment = 100 / (totalDurationMs / intervalMs);

		let current = 0;
		const intervalId = setInterval(() => {
			current += increment;
			if (current >= 100) current = 0;
			setProgress(current);
		}, intervalMs);

		return () => clearInterval(intervalId);
	}, []);

	return (
		<div className="border border-1 border-black flex items-center ">
			<div className="flex h-16 w-20 flex-col justify-center px-1">
				<div className="w-full h-2 bg-gray-200 rounded">
					<div className="h-full bg-blue-500 rounded transition-[width] duration-100 linear" style={{ width: `${progress}%` }} />
				</div>
				<div className="mt-1 text-[10px] text-center">Processing...</div>
			</div>
		</div>
	);
}

export default ImagesInSQSItem;
